import React, { useEffect, useState, useRef } from "react";

function Counter() {
  const [schools, setSchools] = useState(0);
  const [parents, setParents] = useState(0);
  const [orders, setOrders] = useState(0);
  const [satisfaction, setSatisfaction] = useState(0);
  const [start, setStart] = useState(false);

  const sectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const sectionTop = sectionRef.current.offsetTop;
      const scrollPosition = window.scrollY + window.innerHeight;

      if (scrollPosition >= sectionTop + 100) {
        setStart(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!start) return;

    const timer = setInterval(() => {
      setSchools((prev) => (prev >= 30 ? 30 : prev + 1));
      setParents((prev) => (prev >= 100 ? 100 : prev + 4));
      setOrders((prev) => (prev >= 50 ? 50 : prev + 1));
      setSatisfaction((prev) => (prev >= 98 ? 98 : prev + 2)); 
    }, 50);

    return () => clearInterval(timer);
  }, [start]);

  return (
    <section
      ref={sectionRef}
      style={{
        backgroundColor: "#edf9f5",
        padding: "80px 0",
        textAlign: "center",
      }}
    >
      <div className="container">
        <div className="row g-4">
          
          {[
            { val: schools, label: "Partner Schools", suffix: "+" },
            { val: parents, label: "Happy Parents", suffix: "+" },
            { val: orders, label: "Orders Delivered", suffix: "+" },
            { val: satisfaction, label: "Satisfaction Rate", suffix: "%" }
          ].map((item, index) => (
            <div className="col-md-3 col-6" key={index}>
              <div 
                className="p-4 rounded-4 shadow-sm" 
                style={{ 
                  backgroundColor: "#ffffff", 
                  borderBottom: "4px solid #097969", // Dark green accent line
                  transition: "transform 0.3s ease"
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = "translateY(-10px)"}
                onMouseOut={(e) => e.currentTarget.style.transform = "translateY(0)"}
              >
                <h2 className="fw-bold mb-1" style={{ fontSize: "40px", color: "#097969" }}>
                  {item.val}{item.suffix}
                </h2>
                <p className="text-muted fw-semibold small mb-0 uppercase" style={{ letterSpacing: "1px" }}>
                  {item.label}
                </p>
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}

export default Counter;